const GEN_COOKIE_4AI_JS_URI = 'scripts/cookie_4ai.080b3905.js';
const GEN_COOKIE_4AI_CSS_URI = 'styles/cookie/cookie_4ai.a8b49034.css';
const GEN_BOBBY_JS_URI = 'scripts/bobby.443bbace.js';
const GEN_WEBPUSH_JS_URI = 'scripts/webpush.0cb854f8.js';
const GEN_OFFLINE_JS_URI = 'scripts/offline.22b00d7b.js';

function loadCookieConsent() {
	return new loadExt(
		[assetUrl(GEN_COOKIE_4AI_JS_URI), assetUrl(GEN_COOKIE_4AI_CSS_URI)],
		() => {
			return new cookieConsentJS();
		}
	);
}

function getDefaultsGa() {
	let defaults = {
		dimension1: 'online',
		dimension2: 'proxied',
		// send available width x height (not absolute)
		ScreenResolution: `${window.screen.availWidth}x${window.screen.availHeight}`,
		ViewportSize: `${document.documentElement.clientWidth}x${document.documentElement.clientHeight}`,
		//'DocumentEncoding': document.inputEncoding,
		UserLanguage: navigator.language || navigator.userLanguage,
		DocumentTitle: document.title,
		UserAgentOverride: navigator.userAgent,
		/*
        'PageLoadTime': window.performance.timing.loadEventEnd - window.performance.timing.navigationStart,
        'DnsTime': window.performance.timing.domainLookupEnd - window.performance.timing.domainLookupStart,
        'PageDownloadTime': window.performance.timing.responseEnd - window.performance.timing.requestStart,
        'ServerResponseTime': window.performance.timing.responseStart - window.performance.timing.requestStart,
        'DomInteractiveTime': window.performance.timing.domInteractive - window.performance.timing.navigationStart,
        'SessionControl': undefined,
        'UserTimingCategory': undefined,
        'UserTimingVariableName': undefined,
        'UserTimingTime': undefined,
        'UserTimingLabel': undefined,
        'GeographicalOverride': undefined,
        */
	};

	// campaign info
	if (location.search) {
		const qs = new URLSearchParams(location.search);
		const keys = {
			utm_id: 'CampaignId',
			utm_source: 'CampaignSource',
			utm_medium: 'CampaignMedium',
			utm_campaign: 'CampaignName',
			utm_term: 'CampaignKeyword',
			utm_content: 'CampaignContent',
		};
		for (const [utmkey, trackkey] of Object.entries(keys)) {
			if (qs.has(utmkey)) {
				defaults[trackkey] = qs.get(utmkey);
			}
		}
	}

	return Object.assign({}, defaults, js_params.bobby_data);
}

function loadBobby() {
	return new loadExt([assetUrl(GEN_BOBBY_JS_URI)], () => {
		gap('send', 'pageview', getDefaultsGa());
	});
}

function loadGoogleAnalytics() {
	/* DEFAULT FROM GOOGLE
    loadExt(['https://www.googletagmanager.com/gtag/js?id=' + js_params.ga_uid + '.js']);
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', js_params.ga_uid);*/

	window.dataLayer = window.dataLayer || [];
	function gtag() {
		dataLayer.push(arguments);
	}
	gtag('js', new Date());
	return new loadExt(
		['https://www.googletagmanager.com/gtag/js?id=' + js_params.ga_uid + '.js'],
		() => {
			console.debug(
				"GTAG : Google tag manager initié avec l'id suivant : " +
					js_params.ga_uid
			);

			// Test gaData to acknowledge adblocker/anti-tracking usage
			if (window.gaData !== undefined) {
				// Set default value of custom dimension 1 to 'online' (GA4)
				gtag('config', js_params.ga_uid, {
					siteSpeedSampleRate: js_params.siteSpeedSampleRate || 1,
					dimension1: 'online',
				});
			} else {
				// If consent OK but adblocker active, server method triggered
				console.debug('Server hit');
				loadBobby();
			}
		}
	);

	/* OLD
    window.ga = window.ga || function () {
        (ga.q = ga.q || []).push(arguments)
    };
    ga.l = +new Date;
    ga('create', js_params.ga_uid, 'auto', {'siteSpeedSampleRate': js_params.siteSpeedSampleRate || 1});
    // Set default value of custom dimension 1 to 'online'
    ga('set', 'dimension1', 'online');

    return new loadExt([
        'https://www.google-analytics.com/analytics.js'
    ], () => {
        console.debug("GA : Google analytics initié avec l'id suivant : " + js_params.ga_uid);
        ga('send', 'pageview');
    })*/
}

function loadWebPush() {
	return new loadExt([assetUrl(GEN_WEBPUSH_JS_URI)], async () => {
		webPushInit();
	});
}

function loadServiceWorker() {
	const env = window.location.host === 'www.artwai.com' ? 'prod' : 'dev';
	return new loadExt(
		[
			assetUrl(`lib/workbox/workbox-window.${env}.umd.js`),
			assetUrl(GEN_OFFLINE_JS_URI),
		],
		async () => {
			if ('serviceWorker' in navigator) {
				const wb = new workbox.Workbox('/workbox_sw.js');

				wb.addEventListener('waiting', () => {
					new createUIPrompt(
						'app-update',
						'La PWA artwai.com doit effectuer une mise à jour.',
						{
							onAccept: async () => {
								wb.messageSW({ type: 'CLEAN_CACHE' });

								wb.addEventListener('controlling', () => {
									window.location.reload();
								});

								wb.messageSW({ type: 'SKIP_WAITING' });
							},
						}
					).show();
				});

				wb.register();
				this.dispatchEvent(
					new CustomEvent('wbregistered', { detail: { workbox: wb } })
				);
			}
		}
	);
}

window.addEventListener('load', async () => {
	if (is_service_worker_enabled()) {
		loadServiceWorker();
	}
});

window.addEventListener('load', async () => {
	if (is_webpush_available()) {
		loadWebPush();
	}
});

window.addEventListener('load', async () => {
	let consentStatsObj = readCookie('consent_statistiques');
	let consentStats = '';
	if (consentStatsObj != false) {
		consentStats = JSON.parse(consentStatsObj);
	}

	if (consentStatsObj === false) {
		loadCookieConsent();
		if (js_params.ga_proxy) {
			loadBobby();
		}
	} else if (consentStats.value !== 1 && js_params.ga_proxy) {
		loadBobby();
	} else if (js_params.ga_enabled) {
		loadGoogleAnalytics();
	}
});

window.addEventListener('load', async () => {
	if (!('indexedDB' in window)) {
		a4ilog.warn(
			"This browser doesn't support IndexedDB. Perfomances may be impacted"
		);
		return;
	}

	const db_name = 'memshare';
	const db_version = 2;

	let idb = window.indexedDB;

	// Open a db instance
	let request = idb.open(db_name, db_version);

	request.onerror = (event) =>
		a4ilog.error('Database error: ' + event.target.errorCode);

	// Create or update the database structure
	request.onupgradeneeded = (event) => {
		const db = event.target.result;

		const offlineStore = db.createObjectStore(db_name, { keyPath: 'key' });
		offlineStore.createIndex('value', 'value');
	};

	request.onsuccess = (event) => {
		// Get db instance
		const db = event.target.result;

		// Open a transaction
		const transaction = db.transaction([db_name], 'readwrite');

		// Select offline-pages object store (table)
		const memshare = transaction.objectStore(db_name);
		const connected = memshare.get('connected');

		connected.onsuccess = () => {
			const connected = document.cookie.search('user_connected') >= 0;
			memshare.put({ key: 'connected', value: connected });
		};
	};
});

document.addEventListener('DOMContentLoaded', async () => {
	const prevArrowHtml = '<button type="button" class="slick-prev arrow--white" title="précédent"><span aria-hidden="true" class="ico" data-ico="chevronleft"></span></button>';
	const nextArrowHtml = '<button type="button" class="slick-next arrow--white" title="suivant"><span aria-hidden="true" class="ico" data-ico="chevronright"></span></button>';

	jQuery('.single-programmes .testimonials').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		adaptiveHeight: true,
		variableWidth: false,
		autoplay: true,
		autoplaySpeed: 5000,
		prevArrow:
			'<button type="button" class="slick-prev"><span class="ico" data-ico="chevronleft"></span></button>',
		nextArrow:
			'<button type="button" class="slick-next"><span class="ico" data-ico="chevronright"></span></button>',
	});
	jQuery('.sliderImages__slides').slick({
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 2,
		adaptiveHeight: false,
		variableWidth: false,
		autoplay: true,
		autoplaySpeed: 5000,
		prevArrow:
			'<button type="button" class="slick-prev"><span class="ico" data-ico="chevronleft"></span></button>',
		nextArrow:
			'<button type="button" class="slick-next"><span class="ico" data-ico="chevronright"></span></button>',
	});
	jQuery('.single-program .atouts-icons').slick({
		dots: false,
		arrows: false,
		infinite: true,
		speed: 300,
		slidesToShow: 5,
		rows: 1,
		adaptiveHeight: false,
		variableWidth: false,
		centerMode: true,
		asNavFor: '.atouts-titles',
		centerPadding: '0',
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3,
				},
			},
		],
	});

	jQuery('.single-program .atouts-titles').slick({
		dots: true,
		arrows: false,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		adaptiveHeight: true,
		variableWidth: false,
		centerMode: true,
		asNavFor: '.atouts-icons',
		centerPadding: '0',
		autoplay: false,
		autoplaySpeed: 5000,
	});

	if (jQuery('.sliderProgrammes__slides').length > 0) {
		jQuery('.sliderProgrammes__slides').slick({
			centerMode: true,
			prevArrow: prevArrowHtml,
			nextArrow: nextArrowHtml,
			centerPadding: '110px',
			responsive: [
				{
					breakpoint: 1400,
					settings: {
						centerPadding: '8%',
					}
				},
			]
		});
	}

	if (jQuery('.programsList__slider').length > 0) {
		jQuery('.programsList__slider').slick({
			slidesToShow: 3,
			infinite:false,
			prevArrow: prevArrowHtml,
			nextArrow: nextArrowHtml,
			responsive: [
				{
					breakpoint: 960,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 575,
					settings: "unslick"
				},
			],
		});
	}

	if (jQuery('.programsList__slider--small').length > 0) {
		jQuery('.programsList__slider--small').slick({
			slidesToShow: 2,
			infinite:false,
			prevArrow: prevArrowHtml,
			nextArrow: nextArrowHtml,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					}
				}
			],
		});
	}

	if (jQuery('.list-of-post__slider').length > 0) {
		jQuery('.list-of-post__slider').slick({
			slidesToShow: 3,
			arrows: false,
			infinite:false,
			prevArrow: prevArrowHtml,
			nextArrow: nextArrowHtml,
			responsive: [
				{
					breakpoint: 1100,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 650,
					settings: {
						slidesToShow: 1,
						arrows: true,
					}
				},
			],
		});
	}

	if (jQuery('.testimonials-container.design--v2 .testimonials').length > 0) {
		jQuery('.testimonials-container.design--v2 .testimonials').slick({
			slidesToShow: 3,
			infinite:false,
			prevArrow: prevArrowHtml,
			nextArrow: nextArrowHtml,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						arrows: false,
					}
				},
			],
		});
	}
		
	jQuery('.filter_tags label[data-button]').on('click', function () {
		let parent = this.closest('.list_of_posts-section');
		const allLink = parent.querySelector('.all-link a');
		const allLinkTitle = allLink.querySelector('.link-title');
		const allLinkIcon = allLink.querySelector('.ico');
		let data = this.getAttribute('data-button');

		if (data === null || allLink === null) {
			return;
		}

		let dataJson = JSON.parse(data);

		if (dataJson.link.title !== null && dataJson.link.title !== '') {
			allLinkTitle.innerText = dataJson.link.title;
		}

		if (dataJson.link.url !== null && dataJson.link.url !== '') {
			allLink.href = dataJson.link.url;
		}

		if (dataJson.icon !== null && dataJson.icon !== '') {
			allLinkIcon.setAttribute('data-ico', dataJson.icon);
		}

		if (dataJson.style !== null && dataJson.style !== '') {
			allLink.classList = dataJson.style;
		}

		if (dataJson.position_icon == 'left') {
			allLink.classList.add('icon-left');
		}
	});

	navTabs();
	duplicatedButtonClick();
	customFormMessages();
	customDatepickerDispo();
});

jQuery('button.open-search-mobile').on('click', function () {
	jQuery(this).parent().addClass('active');
});
jQuery('button.close-search-mobile').on('click', function () {
	jQuery('#filters-archive-programmes-container').removeClass('active');
});

// if we touch outside of #filters-archive-programmes-container and #filters-archive-programmes-container is active, we close it
jQuery(document).on('click', function (e) {
	if (
		jQuery('#filters-archive-programmes-container').hasClass('active') &&
		!jQuery(e.target).closest('#filters-archive-programmes-container').length
	) {
		jQuery('#filters-archive-programmes-container').removeClass('active');
	}
});

// function to manage tabs in content pages
function navTabs() {
	let tabsContainers = document.querySelectorAll('.tabs');

	if (tabsContainers.length === 0) {
		return;
	}

	tabsContainers.forEach((tabsContainer) => {
		let tabsLinks = tabsContainer.querySelectorAll('.nav-link');

		tabsLinks.forEach((tabsLink) => {
			tabsLink.addEventListener('click', function (e) {
				e.preventDefault();
				let target = this.getAttribute('href');
				let parent = this.closest('.tabs');
				let content = parent.querySelector('.tab-content');
				let hasLLI = false;
				let isLLI = false;

				// if button has data attribute data-eligibility && value is lli, we have to know it
				if( this.hasAttribute('data-lli')) {
					hasLLI = true;
				}
				if (hasLLI && this.getAttribute('data-lli') === 'true') {
					isLLI = true;
				} 
				if (target === null || content === null) {
					return;
				}

				let tabContent = content.querySelectorAll('.tab-pane');

				tabContent.forEach((tab) => {
					tab.classList.remove('active');
				});

				tabsLinks.forEach((tab) => {
					tab.classList.remove('active');
					tab.classList.remove('-primary');
					tab.classList.add('-secondary');
				});

				// hide lots that are not related to the tab
				let type = target.replace('#', '');
				let types = ['habiter', 'investir'];
				if (types.includes(type)) {
					let hiddenType = types.filter((item) => item !== type);
					let lotsHidden = document.querySelectorAll(
						'.lot[data-' + hiddenType + '="true"]'
					);
					lotsHidden.forEach((lot) => {
						lot.style.display = 'none';
					});
					let lotsVisible = document.querySelectorAll(
						'.lot[data-' + type + '="true"]'
					);
					lotsVisible.forEach((lot) => {
						lot.style.display = 'grid';
					});

					// get duplicated button and apply the same logic
					let duplicatedButtonActive = document.querySelector(
						'.duplicated-button[data-type="' + type + '"]'
					);
					let duplicatedButtonInactive = document.querySelector(
						'.duplicated-button[data-type="' + hiddenType + '"]'
					);

					if (duplicatedButtonActive !== null) {
						duplicatedButtonActive.classList.add('active');
						duplicatedButtonActive.classList.add('-primary');
						duplicatedButtonActive.classList.remove('-secondary');
					}

					if (duplicatedButtonInactive !== null) {
						duplicatedButtonInactive.classList.remove('active');
						duplicatedButtonInactive.classList.remove('-primary');
						duplicatedButtonInactive.classList.add('-secondary');
					}

					// update each .nombre to match the number of visible lots, depending on count-"type" attribute
					let countValues = document.querySelectorAll('.nombre .value');
					countValues.forEach((countValue) => {
						countValue.innerText = countValue.getAttribute('count-' + type);
					});

					if (hasLLI) {
						let lots = document.querySelectorAll('.lot');
						lots.forEach((lot) => {
							let priceElement = lot.querySelector('.prix .value');
							let tvaElement = lot.querySelector('.prix .tva-badge');
							let tvaLliElement = lot.querySelector('.prix .tva-badge--lli');
							let price = null;
							if (priceElement !== null ) {
								price =  priceElement.getAttribute('data-price');
							}

							if (isLLI) {
								if (tvaElement !== null ) tvaElement.style.display = 'none';
								if (tvaLliElement !== null) tvaLliElement.style.display = 'inline-block';
								price = priceElement.getAttribute('data-price-lli');
							} else {
								if (tvaElement !== null ) tvaElement.style.display = 'inline-block';
								if (tvaLliElement !== null)	tvaLliElement.style.display = 'none';
							}
							
							if (price !== null) {
								priceElement.innerText = price;
							}

						});

						document.querySelectorAll('.list-appartements .prix-min').forEach((element) => {
							if(isLLI) {
								element.style.textDecoration = 'line-through';
								element.style.color = '#999';
							} else{
								element.style.textDecoration = '';
								element.style.color = '';
							}
						});
					}
				}

				let tabActive = content.querySelector(target);

				if (tabActive !== null) {
					tabActive.classList.add('active');
				}

				this.classList.remove('-secondary');
				this.classList.add('active');
				this.classList.add('-primary');
			});
		});
	});
}

function duplicatedButtonClick() {
	let buttons = document.querySelectorAll('.duplicated-button');

	if (buttons.length === 0) {
		return;
	}

	buttons.forEach((button) => {
		let type = button.getAttribute('data-type');
		let realButton = document.querySelector('#' + type + '-tab');

		if (realButton === null) {
			return;
		}

		button.addEventListener('click', function (e) {
			e.preventDefault();
			realButton.click();

			buttons.forEach((button) => {
				button.classList.remove('active');
				button.classList.remove('-primary');
				button.classList.add('-secondary');
			});

			this.classList.add('active');
			this.classList.add('-primary');
			this.classList.remove('-secondary');
		});
	});
}

function customFormMessages() {
	let messagesWeek = document.querySelectorAll('.message-week');
	let messagesWeekEnd = document.querySelectorAll('.message-weekend');

	// if current day is not in the weekend, we hide all message-week and show message-weekend
	let currentDate = new Date();
	let currentDay = currentDate.getDay();
	let isWeekend = currentDay === 0 || currentDay === 6 || currentDay === 5; // include friday as weekend

	messagesWeek.forEach((message) => {
		message.style.display = isWeekend ? 'none' : 'block';
	});
	messagesWeekEnd.forEach((message) => {
		message.style.display = isWeekend ? 'block' : 'none';
	});
}

function getJoursFeries(year) {
	let bankHolidays = [
		`${year}-01-01`, // Jour de l'an
		`${year}-05-01`, // Fête du travail
		`${year}-05-08`, // Victoire 1945
		`${year}-07-14`, // Fête nationale
		`${year}-08-15`, // Assomption
		`${year}-11-01`, // Toussaint
		`${year}-11-11`, // Armistice 1918
		`${year}-12-25`, // Noël
	];

	bankHolidays = bankHolidays.map((date) => new Date(date));

	// Calcul de la date de Pâques
	const easterDate = calculateEaster(year);

	// Ajout des jours fériés liés à Pâques
	bankHolidays.push(easterDate); // Pâques
	bankHolidays.push(addDays(easterDate, 1)); // Lundi de Pâques
	bankHolidays.push(addDays(easterDate, 39)); // Ascension

	// On ne renvoie pas la Pentecôte parce qu'on travaille :'(
	// bankHolidays.push(formatDate(addDays(easterDate, 50))); // Pentecôte

	return bankHolidays;
}

// Fonction pour calculer la date de Pâques (algorithme de Meeus/Jones/Butcher)
function calculateEaster(year) {
	const a = year % 19;
	const b = Math.floor(year / 100);
	const c = year % 100;
	const d = Math.floor(b / 4);
	const e = b % 4;
	const f = Math.floor((b + 8) / 25);
	const g = Math.floor((b - f + 1) / 3);
	const h = (19 * a + b - d - g + 15) % 30;
	const i = Math.floor(c / 4);
	const k = c % 4;
	const l = (32 + 2 * e + 2 * i - h - k) % 7;
	const m = Math.floor((a + 11 * h + 22 * l) / 451);
	const month = Math.floor((h + l - 7 * m + 114) / 31);
	const day = ((h + l - 7 * m + 114) % 31) + 1;

	return new Date(year, month - 1, day); // Mois en JavaScript : 0-indexé
}

// Fonction pour ajouter des jours à une date
function addDays(date, days) {
	const result = new Date(date);
	result.setDate(result.getDate() + days);
	return result;
}

function customDatepickerDispo() {
	let dateInputs = document.querySelectorAll('.date-disponibilite');

	if (dateInputs.length === 0) {
		return;
	}

	dateInputs.forEach((input) => {
		// heure input is a selected field (options are "9h00" "9h30" "10h00" "10h30" "11h00" "11h30" "12h00" "12h30" "13h00" "13h30" "14h00" "14h30" "15h00" "15h30" "16h00" "16h30" "17h00" "17h30" "18h00" "18h30" "19h00" "19h30")
		const heureInput = input.parentNode.parentNode.parentNode.querySelector(
			'.heure-disponibilite'
		);

		// initialize jquery datepicker
		console.debug('init datepicker');
		// use https://github.com/qodesmith/datepicker
		const picker = datepicker(input, {
			format: 'dd/mm/yyyy',
			formatter: (input, date, instance) => {
				input.value = date.toLocaleDateString();
			},
			minDate: new Date(),
			maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
			autoClose: true,
			inline: true,
			disabler: (date) => date.getDay() === 0 || date.getDay() === 6,
			customDays: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
			customMonths: [
				'Janvier',
				'Février',
				'Mars',
				'Avril',
				'Mai',
				'Juin',
				'Juillet',
				'Août',
				'Septembre',
				'Octobre',
				'Novembre',
				'Décembre',
			],
			disabledDates: [
				...getJoursFeries(new Date().getFullYear()),
				...getJoursFeries(new Date().getFullYear() + 1),
				new Date(),
			],
			startDay: 1,
			position: 'bl',
			zIndex: 1000,
			onSelect: (instance, date) => {
				let selectedDay = date.getDay();
				let selectedHour = heureInput.value;
				let options = heureInput.querySelectorAll('option');

				let disabledDates = getJoursFeries(new Date().getFullYear());

				let isAfterDisabled = false;
				disabledDates.forEach((disabledDate) => {
					let nextDate = new Date(disabledDate);
					nextDate.setDate(disabledDate.getDate() + 1);
					if (
						nextDate.getDate() === date.getDate() &&
						nextDate.getMonth() === date.getMonth()
					) {
						isAfterDisabled = true;
					}

					if (isAfterDisabled) {
						return;
					}
				});

				options.forEach((option) => {
					// create date from option value
					let date = new Date();
					let hour = option.value.split('h');
					date.setHours(hour[0]);
					date.setMinutes(hour[1]);
					date.setSeconds(0);

					let now = new Date();

					option.removeAttribute('disabled');

					// if it is 17h30 and selected date is tomorrow (today+1 day), disable all options before 10h30
					if (now.getHours() > 17 && selectedDay ===  now.getDate() + 1) {
						if (
							date.getHours() < 10 ||
							(date.getHours() === 10 && date.getMinutes() < 30)
						) {
							option.setAttribute('disabled', 'disabled');
							if (option.value === selectedHour) {
								option.removeAttribute('selected');
								heureInput.value = '10h30';
							}
						}
					}



					// if selected date is monday or after disabled, limite options from 13h to 19h30
					if (selectedDay === 1 || isAfterDisabled) {
						if (
							date.getHours() < 13 ||
							(date.getHours() === 13 && date.getMinutes() < 0) ||
							date.getHours() > 19 ||
							(date.getHours() === 19 && date.getMinutes() > 30)
						) {
							option.setAttribute('disabled', 'disabled');
							if (option.value === selectedHour) {
								option.removeAttribute('selected');
								heureInput.value = '13h00';
							}
						}
					}
				});
			},
		});
	});
}
